import { Button, Modal } from 'antd';
import React, { useContext } from 'react';
import { AppContext } from '../../../AppContext';
import { WrongIcon } from '../../../assets/svg';

const BulkExportModal = ({ visible, onCancel, onConfirm, loading }) => {
  const { getCurrentUser } = useContext(AppContext);
  const currentUser = getCurrentUser();

  const handleConfirm = () => {
    if (onConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
  };

  const handleCancel = () => {
    if (onCancel && typeof onCancel === 'function') {
      onCancel();
    }
  };

  return (
    <Modal
      maskClosable={false}
      centered
      open={visible}
      closeIcon={<WrongIcon />}
      footer={null}
      onCancel={handleCancel}
      width={500}
      title="Generate Download Link"
      className="bulk-export-modal"
    >
      <div>
        <p>
          Are you sure, you want to generate report download link and send to
          your registered email id?
        </p>

        {currentUser?.email && (
          <p className="email-info-text">
            Report will be sent to: <strong>{currentUser?.email}</strong>
          </p>
        )}

        <div className="warning-note-box">
          <p className="note-title">Note:</p>
          <ol className="note-list">
            <li>
              EQC QC report link can be generated for maximum 1 month duration.
            </li>
            <li>Max of 5 links can be generated at a time.</li>
            <li>
              Link will be generated from 08:00 pm onward and will be mail to
              your registered email id once link is generated.
            </li>
            <li>
              If generated link has more than 50 reports then multiple link in
              the batch of 50 EQC will be sent in the single mail.
            </li>
          </ol>
        </div>

        <div className="button-container-right">
          <Button
            shape="round"
            onClick={handleCancel}
            disabled={loading}
            className="button-margin-right"
          >
            No, Cancel
          </Button>
          <Button
            type="primary"
            shape="round"
            onClick={handleConfirm}
            loading={loading}
            disabled={loading}
          >
            Yes, Generate
          </Button>
        </div>
      </div>
    </Modal>
  );
};

BulkExportModal.defaultProps = {
  visible: false,
  loading: false,
};

export default BulkExportModal;
